<script>
import BaseContainer from '@/components/default/views/shared/BaseContainer.vue'
export default {
	name: 'BasePanel',
	components: {
		BaseContainer
	}
}
</script>

<template>
	<div class="base-panel">
		<base-container class="base-panel__container" modifiers="default-width column-layout">
			<div class="base-panel__header">
				<slot name="header"></slot>
			</div>
			<div class="base-panel__content">
				<div class="base-panel__information">
					<slot name="information"></slot>
				</div>
				<div class="base-panel__actions">
					<slot name="actions"></slot>
				</div>
			</div>
		</base-container>
	</div>
</template>

<style lang="scss">
	.base-panel {
		display: flex;
		justify-content: center;
		width: 100vw;
		background-color: var(--panel-bg-colour);
		color: var(--panel-text-colour);
		padding: 1rem 2rem;
		@media (max-width: 600px) {
			padding: 0.5rem 0.75rem;
		}
		@media (max-width: 320px) {
			height: 225px;
		}
		&__container {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			@media (max-width: 500px) {
				flex-direction: column;
			}
		}
		&__header {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			margin: 0.5rem 0;
			font-size: 1.5rem;
			@media (max-width: 500px) {
				font-size: 1.2rem;
			}
		}
		&__content {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			margin: 0.5rem 0;
			@media (max-width: 500px) {
				flex-direction: column;
			}
		}
		&__information {
			display: flex;
			flex-direction: row;
			align-items: flex-end;
			height: 100%;
			max-width: 60%;
			flex-wrap: wrap;
			@media (max-width: 600px) {
				max-width: 70%;
			}
			@media (max-width: 500px) {
				max-width: 100%;

				align-self: flex-start;
				margin-bottom: 0.5rem;
			}
			@media (min-width: 620px) {
				min-height: 85px;
			}
		}
		&__actions {
			display: flex;
			flex-direction: column;
			justify-content: space-evenly;
			align-items: flex-end;
			@media (max-width: 500px) {
				width: 100%;
			}
		}
	}
</style>
